export enum Sports {
  FOOTBALL = 'football',
  BASKETBALL = 'basketball',
  TENNIS = 'tennis',
  MULTISPORT = 'multisport',
  ICE_HOCKEY = 'ice-hockey',
}

export enum FootballStandingsElements {
  MATCHES_PLAYED = 'matches_played',
  MATCHES_WON = 'matches_won',
  MATCH_LOSSES = 'match_losses',
  MATCH_DRAW = 'match_draw',
  GOAL_DIFFERENCE = 'goal_difference',
  POINTS = 'points',
  TEAM_FORM = 'team_form',
}

export enum TableVariants {
  STATS = 'stats_table',
  STANDINGS = 'standings',
  DEFAULT = 'default',
}

export const validForCustomSportsStyles = ['ice-hockey'];
